import React from "react";

const TECH = [
  { name: "Python", slug: "python" },
  { name: "n8n", slug: "n8n" },
  { name: "WordPress", slug: "wordpress" },
  { name: "Elementor", slug: "elementor" },
  { name: "Gemini", slug: "googlegemini" },
  { name: "Claude", slug: "anthropic" },
  { name: "Hugging Face", slug: "huggingface" },
  { name: "LangChain", slug: "langchain" },
  { name: "FastAPI", slug: "fastapi" },
  { name: "React", slug: "react" },
  { name: "Node.js", slug: "nodedotjs" },
  { name: "MongoDB", slug: "mongodb" },
  { name: "Docker", slug: "docker" },
  { name: "Vercel", slug: "vercel" },
  { name: "Supabase", slug: "supabase" },
  { name: "Telegram", slug: "telegram" },
  { name: "Stripe", slug: "stripe" },
  { name: "GitHub", slug: "github" },
];

// Light, glowing purple monochrome logos via simpleicons CDN
const iconUrl = (slug) => `https://cdn.simpleicons.org/${slug}/B026FF`;
const iconUrlWhite = (slug) => `https://cdn.simpleicons.org/${slug}/FFFFFF`;

export const TechStack = () => {
  // duplicate for seamless infinite scroll
  const loop = [...TECH, ...TECH];
  return (
    <section
      id="tech-stack"
      data-testid="tech-stack-section"
      className="relative py-20 sm:py-24 overflow-hidden border-y border-white/5"
    >
      {/* subtle scan-line / grid bg */}
      <div className="absolute inset-0 grid-bg opacity-30 pointer-events-none" />
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#B026FF]/40 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-[#B026FF]/40 to-transparent" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 mb-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <p className="text-xs uppercase tracking-[0.22em] text-[#B026FF] mb-3 flex items-center gap-2">
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#B026FF] shadow-[0_0_8px_rgba(176,38,255,0.9)]" />
              Powered By
            </p>
            <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-white">
              The control center.
            </h2>
          </div>
          <p className="text-white/55 max-w-md text-sm">
            A curated, battle-tested toolchain for shipping production AI,
            automation, and web systems — fast.
          </p>
        </div>
      </div>

      {/* Marquee */}
      <div
        data-testid="tech-marquee"
        className="tech-marquee relative"
        style={{
          maskImage:
            "linear-gradient(90deg, transparent, black 8%, black 92%, transparent)",
          WebkitMaskImage:
            "linear-gradient(90deg, transparent, black 8%, black 92%, transparent)",
        }}
      >
        <div className="flex gap-4 marquee-track w-max items-stretch">
          {loop.map((t, i) => (
            <TechCard key={`${t.slug}-${i}`} tech={t} index={i} />
          ))}
        </div>
      </div>

      {/* Footer status row */}
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 mt-10 flex items-center justify-between font-mono-ui text-[10px] uppercase tracking-widest text-white/40">
        <div className="flex items-center gap-2">
          <span className="inline-block w-1.5 h-1.5 rounded-full bg-emerald-400 shadow-[0_0_6px_rgba(52,211,153,0.9)] animate-pulse" />
          STACK_ONLINE
        </div>
        <span className="hidden sm:inline">{TECH.length}+ integrations · 99.99% uptime</span>
        <span>v2.4.1</span>
      </div>
    </section>
  );
};

const TechCard = ({ tech }) => (
  <div
    data-testid={`tech-card-${tech.slug}`}
    className="tech-card group relative shrink-0 w-44 h-32 rounded-xl border border-white/8 bg-white/[0.02] backdrop-blur-sm flex flex-col items-center justify-center gap-3 transition-all duration-300 hover:border-[#B026FF]/55 hover:bg-[#B026FF]/[0.06] hover:shadow-[0_0_30px_rgba(176,38,255,0.25)]"
  >
    <div className="relative w-9 h-9 flex items-center justify-center">
      {/* monochrome purple by default */}
      <img
        src={iconUrl(tech.slug)}
        alt={tech.name}
        loading="lazy"
        className="w-9 h-9 object-contain transition-opacity duration-300 group-hover:opacity-0"
        style={{ filter: "drop-shadow(0 0 6px rgba(176,38,255,0.55))" }}
      />
      {/* white-glow logo on hover */}
      <img
        src={iconUrlWhite(tech.slug)}
        alt=""
        aria-hidden="true"
        loading="lazy"
        className="absolute inset-0 w-9 h-9 object-contain opacity-0 transition-opacity duration-300 group-hover:opacity-100"
        style={{ filter: "drop-shadow(0 0 12px rgba(176,38,255,0.95))" }}
      />
    </div>
    <span className="text-[11px] uppercase tracking-widest text-white/60 group-hover:text-white transition-colors">
      {tech.name}
    </span>
    {/* corner ticks */}
    <span className="absolute top-1.5 left-1.5 w-2 h-2 border-t border-l border-white/15 group-hover:border-[#B026FF]/70 transition-colors" />
    <span className="absolute top-1.5 right-1.5 w-2 h-2 border-t border-r border-white/15 group-hover:border-[#B026FF]/70 transition-colors" />
    <span className="absolute bottom-1.5 left-1.5 w-2 h-2 border-b border-l border-white/15 group-hover:border-[#B026FF]/70 transition-colors" />
    <span className="absolute bottom-1.5 right-1.5 w-2 h-2 border-b border-r border-white/15 group-hover:border-[#B026FF]/70 transition-colors" />
  </div>
);
